import React from 'react';

export const NoAccessIcon = ({width, height}: {width: number; height: number}) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 48 48" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.4194 33V27.0035C32.4194 24.6241 30.4596 22.6774 28.0646 22.6774H19.3553C16.9599 22.6774 15 24.6241 15 27.0035V33H32.4194ZM28.5485 17.5164C28.5485 20.0104 26.527 22.0323 24.0328 22.0323C21.5381 22.0323 19.5162 20.0104 19.5162 17.5164C19.5162 15.0219 21.5381 13 24.0328 13C26.527 13 28.5485 15.0219 28.5485 17.5164Z"
        fill="#B1B2B4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M42 23.5C42 33.7173 33.7173 42 23.5 42C13.2827 42 5 33.7173 5 23.5C5 13.2827 13.2827 5 23.5 5C33.7173 5 42 13.2827 42 23.5ZM38 23.5C38 31.5081 31.5081 38 23.5 38C20.1732 38 17.108 36.8796 14.6613 34.9956L34.9956 14.6613C36.8796 17.108 38 20.1732 38 23.5ZM32.1434 11.8566C29.7297 10.0619 26.7389 9 23.5 9C15.4919 9 9 15.4919 9 23.5C9 26.7389 10.0619 29.7297 11.8566 32.1434L32.1434 11.8566Z"
        fill="#FF612B"
      />
    </svg>
  );
};
